import React, { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelCinco.scss";

import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const CUBES = [
  {
    topKey: 13,
    topClicked: false,
    topAdjacent: [14, 12],
    leftKey: 14,
    leftClicked: false,
    leftAdjacent: [13, 12, 15],
    rightKey: 12,
    rightClicked: false,
    rightAdjacent: [13, 14, 11],
  },
  {
    topKey: 15,
    topClicked: false,
    topAdjacent: [14, 16, 17],
    leftKey: 16,
    leftClicked: false,
    leftAdjacent: [15, 17, 1],
    rightKey: 17,
    rightClicked: false,
    rightAdjacent: [15, 16, 18, 10],
  },
  {
    topKey: 11,
    topClicked: false,
    topAdjacent: [12, 10, 9],
    leftKey: 10,
    leftClicked: false,
    leftAdjacent: [17, 11, 18, 9],
    rightKey: 9,
    rightClicked: false,
    rightAdjacent: [11, 10, 8],
  },
  {
    topKey: 8,
    topClicked: false,
    topAdjacent: [9, 6, 7],
    leftKey: 6,
    leftClicked: false,
    leftAdjacent: [5, 8, 7],
    rightKey: 7,
    rightClicked: false,
    rightAdjacent: [6, 8],
  },
  {
    topKey: 18,
    topClicked: false,
    topAdjacent: [17, 10, 4, 5],
    leftKey: 4,
    leftClicked: false,
    leftAdjacent: [3, 18, 5],
    rightKey: 5,
    rightClicked: false,
    rightAdjacent: [4, 18, 6],
  },
  {
    topKey: 1,
    topClicked: false,
    topAdjacent: [16, 2, 3],
    leftKey: 2,
    leftClicked: false,
    leftAdjacent: [1, 3],
    rightKey: 3,
    rightClicked: false,
    rightAdjacent: [1, 2, 4],
  },
];

function LevelCinco() {
  const [cubes, setCubes] = useState(CUBES);
  const [lastClicked, setLastClicked] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  ]);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    firstClickTime: 0,
    clicksBeforeThreeRightClicks: 0,
    firstThreeRightClicks: 0,
    RemainingTimeTakenAfterThreeClicks: 0,
    attemptsBeforeThreeClicks: 0,
    attemptsAfterThreeClicks: 0,
    totalTime: 0,
    totalHints: 0,
  });
  const [timer, setTimer] = useState(0);
  const [attempts, setAttempts] = useState(1);
  const [clicks, setClicks] = useState(0);
  const [righClicks, setRightClicks] = useState(0);

  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  const faceClick = (index, key, position) => {
    setClicks(clicks + 1);
    if (dataPoints.firstClickTime === 0) {
      setDataPoints({
        ...dataPoints,
        firstClickTime: timer,
      });
    }
    if (lastClicked.includes(key)) {
      setRightClicks((prevState) => {
        if (prevState + 1 === 3 && dataPoints.firstThreeRightClicks === 0) {
          setDataPoints({
            ...dataPoints,
            clicksBeforeThreeRightClicks: clicks,
            firstThreeRightClicks: timer,
            attemptsBeforeThreeClicks: attempts,
          });
        }
        return prevState + 1;
      });
      let newCubes = cubes.map((item, i) => {
        if (index == i) {
          setLastClicked(item[`${position}Adjacent`]);
          return { ...item, [`${position}Clicked`]: true };
        } else {
          return item;
        }
      });
      setCubes(newCubes);
    } else {
      let newCubes = cubes.map((item, i) => {
        return {
          ...item,
          topClicked: false,
          leftClicked: false,
          rightClicked: false,
        };
      });
      setLastClicked([
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
      ]);
      setCubes(newCubes);
      setAttempts(attempts + 1);
      setRightClicks(0);
    }
  };

  // Check if won
  useEffect(() => {
    let index = 0;
    while (index < cubes.length) {
      if (
        cubes[index].topClicked === false ||
        cubes[index].leftClicked === false ||
        cubes[index].rightClicked === false
      ) {
        setWon(false);
        break;
      }
      index += 1;
    }
    if (index === cubes.length) {
      setWon(true);
      setDataPoints({
        ...dataPoints,
        totalTime: timer,
        RemainingTimeTakenAfterThreeClicks:
          timer - dataPoints.firstThreeRightClicks,
        attemptsAfterThreeClicks:
          attempts - dataPoints.attemptsBeforeThreeClicks,
      });
    }
  }, [lastClicked]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        setMove(true);
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: 5,
                levelName: "Vicinus",
                firstClickTime: dataPoints.firstClickTime,
                clicksBeforeThreeRightClicks:
                  dataPoints.clicksBeforeThreeRightClicks,
                firstThreeRightClicks: dataPoints.firstThreeRightClicks,
                RemainingTimeTakenAfterThreeClicks:
                  dataPoints.RemainingTimeTakenAfterThreeClicks,
                attemptsBeforeThreeClicks: dataPoints.attemptsBeforeThreeClicks,
                attemptsAfterThreeClicks: dataPoints.attemptsAfterThreeClicks,
                totalTime: timer,
                totalClicks: clicks,
                attempts: attempts,
                isLevelCleared: true,
                isLevelSkipped: false,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint:
                  localStorage.getItem("totalHints") !== 0
                    ? localStorage.getItem("hint1")
                    : 0,
                timeForSecondHint:
                  localStorage.getItem("totalHints") !== 0
                    ? localStorage.getItem("hint2")
                    : 0,
              },
            ],
          },
        };
        console.log(finalObj);
        sendResult(finalObj);
        console.log(dataPoints, attempts, clicks);
      }
    }, 500);
  }, [won]);

  return (
    <div className="component-level-cinco">
      {move && <LevelComplete levelNum={7} />}
      <Navbar won={won} levelNum={7} />
      <div className="game-div">
        {cubes.map((cube, index) => (
          <div className={`cube-${index}`}>
            <div
              className="topFace"
              onClick={() => faceClick(index, cube.topKey, "top")}
            >
              <div className={cube.topClicked ? "clicked" : ""}></div>
            </div>
            <div
              className={"leftFace " + (cube.leftClicked ? "clicked" : "")}
              onClick={() => faceClick(index, cube.leftKey, "left")}
            ></div>
            <div
              className={"rightFace " + (cube.rightClicked ? "clicked" : "")}
              onClick={() => faceClick(index, cube.rightKey, "right")}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LevelCinco;
